// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import remove from '../remove/index.tsx';
import type { State, Callback } from '../types.tsx';

const add =
	<T extends State>(key: string, callback: Callback): Action<T> =>
	// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
	({ setState, getState, dispatch }): (() => void) => {
		// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
		setState({ [key]: new Set(getState()[key]).add(callback) });

		return () => dispatch(remove(key, callback));
	};

export default add;
